export enum WorkflowRunInitType {
    ById = 'ById',
    ReRun = 'ReRun',
    ByActiveWorkflow = 'ByActiveWorkflow',
}
